/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/SystemLists.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for System Lists
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:05 PM (CST)
 *  
 *  Notes:
 *      09/15/2018  NJN     Working on clean up to split out or eliminate code.
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    SYSTEMLIST_LIST_CONTAINER_LOADED,
    SYSTEMLIST_LIST_CONTAINER_UNLOADED,
    SYSTEMLIST_LIST_TABLE_LOADED,
    SYSTEMLIST_LIST_TABLE_UNLOADED,
    SYSTEMLIST_LIST_CHANGE_COMPANY,
    SYSTEMLIST_LIST_CHANGE_LISTGROUP,
    SYSTEMLIST_SELECT_ROW,
    SYSTEMLIST_ADD,
    SYSTEMLIST_EDIT,
    SYSTEMLIST_DELETE,
    SYSTEMLIST_DELETE_DISABLE,
    SYSTEMLIST_OPEN_WARNING,
    SYSTEMLIST_CLOSE_WARNING,
    SYSTEMLIST_EDIT_CONTAINER_LOADED,
    SYSTEMLIST_EDIT_CONTAINER_UNLOADED,
    SYSTEMLIST_EDIT_FORM_LOADED,
    SYSTEMLIST_EDIT_FORM_UNLOADED,
    SYSTEMLIST_EDIT_LOAD_LISTGROUPS,
    SYSTEMLIST_EDIT_CHANGE_COMPANY,
    SYSTEMLIST_EDIT_DATA_LOAD,
    SYSTEMLIST_SET_COMPANY_SELECT,
    SYSTEMLIST_SET_LISTGROUP_SELECT,
    SYSTEMLIST_EDIT_CONTAINER_SUBMIT,
    SYSTEMLIST_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeSystemLists';

const defaultState = {
    refreshList: false,
    systemLists: [],
    companies: [],
    listgroups: [],
    companyOptions: [],
    listGroupOptions: [],
    listGroupDisabled: false,
    danger: false,
    systemlistid: 0,
    listgroupid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case SYSTEMLIST_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                systemlists: action.payload[0] ? action.payload[0].records : [],
                companies: action.payload[1] ? action.payload[1].companies : [],
                listgroups: action.payload[2] ? action.payload[2].records : [],
            }
        case SYSTEMLIST_LIST_CHANGE_COMPANY:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                systemlists: action.payload[0] ? action.payload[0].records : [],
                listgroups: action.payload[1] ? action.payload[1].records : []
            }
        case SYSTEMLIST_LIST_CHANGE_LISTGROUP:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                systemlists: action.payload ? action.payload.records : []
            }
        case SYSTEMLIST_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case SYSTEMLIST_SELECT_ROW:
            return {
                ...state,
                systemlistid: action.id
            }
        case SYSTEMLIST_ADD:
            return {
                ...state
            }
        case SYSTEMLIST_EDIT:
            return {
                ...state,
                systemlistid: action.id
            }
        case SYSTEMLIST_DELETE:
            return {
                ...state,
                systemlistid: null
            }
        case SYSTEMLIST_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case SYSTEMLIST_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case SYSTEMLIST_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case SYSTEMLIST_SET_COMPANY_SELECT:
            return {
                ...state,
                companyOptions: action.payload ? action.payload : []
            }
        case SYSTEMLIST_SET_LISTGROUP_SELECT:
            return {
                ...state,
                listGroupOptions: action.payload ? action.payload : [],
                listGroupDisabled: action.listGroupDisabled
            }
        case SYSTEMLIST_EDIT_CONTAINER_LOADED:
            return {
                ...state,
                companies: action.payload[1] ? action.payload[1].companies : [],
                listgroups: action.payload[2] ? action.payload[2].records : [],
                systemlistid: action.payload[0] ? action.payload[0].systemlistid : 0,
                companyid: action.payload[0] ? action.payload[0].companyid : 0,
                listgroupid: action.payload[0] ? action.payload[0].listgroupid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case SYSTEMLIST_EDIT_DATA_LOAD:
            return {
                ...state,
                systemlistid: action.payload ? action.payload.systemlistid : 0,
                companyid: action.payload ? action.payload.companyid : 0,
                listgroupid: action.payload ? action.payload.listgroupid : 0,
                name: action.payload ? action.payload.name : '',
                description: action.payload ? action.payload.description : '',
                createdate: action.payload ? action.payload.createdate : '',
                modifydate: action.payload ? action.payload.modifydate : ''
            }
        case SYSTEMLIST_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case SYSTEMLIST_EDIT_LOAD_LISTGROUPS:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                listgroups: action.payload ? action.payload.records : []
            }
        case SYSTEMLIST_EDIT_CHANGE_COMPANY:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                listgroups: action.payload ? action.payload.records : []
            }
        case SYSTEMLIST_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case SYSTEMLIST_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case SYSTEMLIST_LIST_CONTAINER_UNLOADED:
        case SYSTEMLIST_LIST_TABLE_UNLOADED:
        case SYSTEMLIST_EDIT_CONTAINER_UNLOADED:
        case SYSTEMLIST_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/SystemLists.js